export const AppDateFormats = {
  parse: {
    dateInput: 'MMM D, YYYY',
  },
  display: {
    dateInput: 'MMM D, YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
